module.exports = {
    cart: {
        clearTrolleyConfirmationMessage:
            'Are you sure you would like to remove all products from the cart?',
        expressUnavailableHeader:
            'Delivery Now is currently unavailable',
        meatStockLossMessage:
            'Weight is approximate. We won\'t overcharge you if we give you more, and we\'ll refund the difference if it\'s less.',
        removeAllProductsLinkText:
            'Remove all products',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/cart.js